"use client";

import {
  LoaderCircle,
  AlertTriangle,
  CheckCircle,
  XCircle,
} from "lucide-react";

/* eslint-disable */
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group !z-[100] font-display"
      icons={{
        loading: (
          <LoaderCircle className="size-5 animate-spin text-brand-primary" />
        ),
        warning: (
          <AlertTriangle className="size-5 text-yellow-500 dark:text-yellow-400" />
        ),
        error: (
          <XCircle className="size-5 text-red-500 dark:text-red-400" />
        ),
        success: (
          <CheckCircle className="size-5 text-emerald-500 dark:text-emerald-400" />
        ),
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-gray-1100 dark:group-[.toaster]:text-gray-100 group-[.toaster]:border-input dark:group-[.toaster]:border-backgroundAccent group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-gray-600 dark:group-[.toast]:text-gray-400",
          actionButton:
            "bg-brand-primary hover:bg-brand-primaryAlpha group-[.toaster]:text-gray-1100 dark:group-[.toaster]:text-gray-100",
          cancelButton:
            "!group-[.toast]:bg-muted group-[.toaster]:text-gray-1100 dark:group-[.toaster]:text-gray-100",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
